<template>
  <div class="system-access">
    <navigator :items="items"></navigator>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12">
                  <h5>Filtros</h5>
                </div>
                <div class="col-lg-3">
                  <div class="d-flex justify-content-center align-items-center form-group-edit">
                    <label for>De</label>
                    <b-form-datepicker
                      id="start-datepicker"
                      v-model="filter.start_date"
                      class="mb-2"
                    ></b-form-datepicker>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="d-flex justify-content-center align-items-center form-group-edit">
                    <label for>Até</label>
                    <b-form-datepicker id="end-datepicker" v-model="filter.end_date" class="mb-2"></b-form-datepicker>
                  </div>
                </div>
                <div class="col-lg-6">
                  <button class="btn btn-primary" v-on:click="providerData()">Pesquisar</button>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <b-table
                    hover
                    :fields="fields"
                    :items="data"
                    :per-page="0"
                    :current-page="currentPage"
                  >
                  <template v-slot:cell(date)="data">{{ formatDate(data.value) }}</template>                    
                  </b-table>
                  <div class="no-data" v-if="data.length == 0">
                    <span>Sem dados</span>
                  </div>
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import { bus } from "@/main";
import moment from "moment";

export default {
  name: "system-access",
  data() {
    return {
      items: [
        {
          text: "Relatório de visitas ao site",
          active: true
        }
      ],
      filter: {
        start_date: "",
        end_date: ""
      },
      data: [],
      fields: [
        { key: "date", label: "Data" },
        { key: "qtd_accesses", label: "Quantidade de acessos" },
        { key: "average_time", label: "Duração média" },
        { key: "average_pages", label: "Média de páginas acessadas" }
      ]
    };
  },
  mounted() {
    this.filter.end_date = moment().format();
    this.filter.start_date = moment()
      .subtract(7, "days")
      .format();
    this.providerData();
  },
  methods: {
    providerData() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_HOST
          }/api/get_report_access_period?${this.urlBuild()}`
        )
        .then(response => {
          this.data = response.data;
          bus.$emit("changeLoading", false);
        });
    },
    urlBuild: function() {
      let url =
        (this.filter.start_date != ""
          ? `start_date=${this.filter.start_date}&`
          : "") +
        (this.filter.end_date != "" ? `end_date=${this.filter.end_date}&` : "");
      return url;
    },
    formatDate: function(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.system-access {
  .form-group-edit {
    label {
      margin-right: 12px;
      font-size: 16px;
    }
  }
}
</style>